import React, { ReactNode, useEffect, useState } from 'react'

import { initialState, StepperContext } from '../context/StepperContext'

interface AttachmentsProviderProps {
  children: ReactNode
}

export const StepperProvider = ({ children }: AttachmentsProviderProps) => {
  const [currentStep, setCurrentStep] = useState<number>(
    initialState.currentStep
  )
  const [stepsQuantity, setStepsQuantity] = useState<number>(
    initialState.stepsQuantity
  )
  const [isLastStep, setIsLastStep] = useState<boolean>(initialState.isLastStep)

  const nextStep = () => {
    if (currentStep < stepsQuantity) {
      setCurrentStep((step) => step + 1)
    }
  }

  const previewStep = () => {
    if (currentStep > 1) {
      setCurrentStep((step) => step - 1)
    }
  }

  const goToStep = (step: number) => {
    setCurrentStep(step)
  }

  const goToLastStep = () => {
    setCurrentStep(stepsQuantity)
  }

  useEffect(() => setIsLastStep(currentStep === stepsQuantity), [
    currentStep,
    stepsQuantity,
  ])

  return (
    <StepperContext.Provider
      value={{
        currentStep,
        stepsQuantity,
        isLastStep,
        nextStep,
        previewStep,
        goToStep,
        goToLastStep,
        setStepsQuantity,
      }}
    >
      {children}
    </StepperContext.Provider>
  )
}
